import React from 'react';
import {
   CLUES,
   CREATED,
   LAST_MODIFIED,
   LAST_PLAYED,
   LOC_NAME,
   PICTURE,
   PUBLIC,
   PUBLISHED,
   TITLE, /*TOTAL_PLAYED,*/ TOTAL_WON
} from "../../constants/Game";
import moment from "moment/moment";
import { GameListing } from "./GameListing";
import { dateTextOrMissing, dateTextOrNone } from "./GameEntryListItem";
import {COMMON_DATE, SHORT_DATE} from "../../constants/Strings";

import './GameListItem.css'
import {Link} from "react-router-dom";

export const AuthoredGameListing = props => {
   const {title, gameList, onGameSelect, canEdit} = props;

   const selectText = canEdit ? " (Select for detail)" : " (Select for detail)";

   return (
      <div>
         <h3 className="HomePage-left-margin-above-bootstrap-list no-wrap">
            {title}
            <small className="full-text"> {selectText} </small>
         </h3>
         <ul className="list-group home-list-margins">
            {gameList ?
               <GameListing
                  games={gameList}
                  onGameSelect={onGameSelect}
                  adminView={false}/>
               : "Loading..."}
         </ul>
      </div>
   )
};

/**
 * A single item in the Game List on the Home page.
 * */
const GameListItem = ({game, onGameSelect, adminView}) => {

   let title = game[TITLE] ? game[TITLE] : "Missing game";
   const isPublished = game[PUBLISHED];
   const isPublic = game[PUBLIC];
   if (!isPublic) title = title + " (private)";
   const locName = game[LOC_NAME] ? game[LOC_NAME] : "Unknown";
   const creationDateText = dateTextOrMissing(game[CREATED], null, COMMON_DATE);
   const lastPlayedDateText = dateTextOrNone(game[LAST_PLAYED], COMMON_DATE);

   const creationDateTextShort = dateTextOrMissing(game[CREATED], null, SHORT_DATE);
   const lastPlayedDateTextShort = dateTextOrNone(game[LAST_PLAYED], SHORT_DATE);

   // Commented out until cloud function is fixed that gets # of games plays right.
   // const totalPlaysLabel = !!game[LAST_PLAYED] ? "Plays: " : ""
   // const totalPlays =  !!game[LAST_PLAYED] ? game[TOTAL_PLAYED] : ""

   const totalCompletedLabel = !!game[LAST_PLAYED] ? "Hunts finished: " : ""
   const totalCompleted =  !!game[LAST_PLAYED] ? game[TOTAL_WON] : ""

   const hasClues = game[CLUES];
   const clueCount = hasClues
      ? game[CLUES].length
      : 0;

   const gamePhoto = game[PICTURE];
   const hasPhoto = !!gamePhoto;

   const hasCreation = game[CREATED];
   const createDate = hasCreation
      ? moment(game[CREATED].toDate())
      : null;

   // If modified date exists and is more than 1 day (24 hours) past creation date, show it.
   let hasModified = !!game[LAST_MODIFIED];
   const modifiedDate = hasModified ?
      moment(game[LAST_MODIFIED].toDate())
      : null;
   hasModified = hasModified && modifiedDate.isAfter(createDate.add(1, 'days'));
   const modifiedDateText = hasModified ? modifiedDate.format("MMM. Do 'YY") : "";
   const modifiedDateTextShort = hasModified ? modifiedDate.format("MMM-D-YY") : "";
   const modifiedLabel = hasModified ? "Updated: " : "";

   // Author text for games played.
   const authorText = game.authorName ? game.authorName : "";
   const authorForLink = authorText.replace(" ","+");
   const authorLink = "/user/"+game.authorId+"/"+authorForLink;

   const titleClass = isPublished
                           ? isPublic
                                 ? "list-group-item-heading"
                                 : "list-group-item-heading admin-red-title"
                           : isPublic
                                 ? "list-group-item-heading admin-grey-title"
                                 : "list-group-item-heading admin-red-grey-title";

   return (
      <li key={title} onClick={() => onGameSelect(game)} className="list-group-item selectable">
         <div>
            { adminView &&
            <div className="pull-right">
                  <Link to={authorLink} className="btn btn-link accent-link">{authorText}</Link>
               { hasPhoto &&
                  <img className="photo-thumb" src={gamePhoto} alt="game"/>
                }
            </div>
            }

            {/*{ adminView &&*/}
            {/*<div className="pull-right">*/}
            {/*</div> }*/}

            <h4 className={titleClass}> {title} </h4>
            <div className="list-group-item-text" align="left"> Location: <span
               className="secondary-highlight right-margin"> {locName} </span>
               { adminView && <span className="secondary-highlight">Clues: {clueCount} </span> } </div>
            <div className="list-group-item-text" align="left"> Created: <span className="secondary-highlight right-margin normal-text">{creationDateText}  </span>
               <span className="secondary-highlight right-margin veryshort-text">{creationDateTextShort}  </span>
               {modifiedLabel} <span className="secondary-highlight right-margin normal-text">{modifiedDateText}  </span>
               <span className="secondary-highlight right-margin veryshort-text">{modifiedDateTextShort}  </span></div>
            <div className="list-group-item-text" align="left"> Last Played:  <span className="accent-link normal-text right-margin">{lastPlayedDateText}  </span>
               <span className="accent-link veryshort-text right-margin">{lastPlayedDateTextShort}  </span>
               {/*Commented out until totalPlays fixed on server.  {totalPlaysLabel} <span className="accent-link right-margin"> {totalPlays}   </span>*/}
               {totalCompletedLabel} <span className="accent-link "> {totalCompleted}   </span>
            </div>
         </div>
      </li>
   );
};

export default GameListItem;



// WEBPACK FOOTER //
// ./src/components/yourpage/GameListItem.js